import React from "react";

interface PropertyListingSkeletonProps {
  cardCount?: number;
}

const PropertyListingSkeleton: React.FC<PropertyListingSkeletonProps> = ({
  cardCount = 12,
}) => {
  return (
    <div className="p-2 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 justify-items-center gap-5 w-full">
      {Array.from({ length: cardCount }).map((_, index) => (
        <div
          key={index}
          className="w-full max-w-[350px] min-w-[300px] bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden animate-pulse"
        >
          <div className="w-full h-48 bg-gray-200" />
          <div className="p-4 space-y-3">
            <div className="flex gap-2">
              <div className="h-6 w-20 bg-gray-200 rounded-full" />
              <div className="h-6 w-20 bg-gray-200 rounded-full" />
            </div>
            <div className="h-4 w-full bg-gray-200 rounded" />
            <div className="h-4 w-2/3 bg-gray-200 rounded" />
            <div className="h-4 w-full bg-gray-200 rounded" />
            <div className="flex gap-2 pt-2">
              <div className="h-8 w-16 bg-gray-200 rounded-lg" />
              <div className="h-8 w-16 bg-gray-200 rounded-lg" />
              <div className="h-8 w-16 bg-gray-200 rounded-lg" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PropertyListingSkeleton;
